module.exports = __webpack_public_path__ + "img/ThinkstockPhotos-516589445.4858d43e.jpg";